import { Component } from '@angular/core';
import { StepperGridComponent } from '../stepper-grid/stepper-grid.component';
import { CoreService } from '../../../services/core.service';
import { saveAs } from 'file-saver';
import { LatestPostsSidebarComponent } from "../latest-posts-sidebar/latest-posts-sidebar.component";
import { Router } from '@angular/router';


@Component({
  selector: 'app-social-ai-download-file',
  standalone: true,
  imports: [StepperGridComponent, LatestPostsSidebarComponent],
  templateUrl: './social-ai-download-file.component.html',
  styleUrl: './social-ai-download-file.component.scss'
})
export class SocialAiDownloadFileComponent {

  constructor(
    private readonly coreService: CoreService,
    private readonly router: Router,
  ){}

  hasDownloaded = false;


  downloadXlsxTemplate(): void {
    this.coreService.getData('/bulks/user-download-xlsx', {}, 'blob').subscribe({
      next: (blob: Blob) => {
        saveAs(blob, 'bulk_upload_template.xlsx');
        this.hasDownloaded = true;
      },
      error: () => this.coreService.showSnackbar('Failed to download XLSX template.')
    });
  }


  submit() {
    if (!this.hasDownloaded) {
      this.coreService.showSnackbar('Please download the template first.');
      return;
    }
    this.router.navigateByUrl('/upload-bulk/social-ai-upload-bulk');
  }
}
